
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { VouchersService } from './vouchers.service';
import { AuthService } from '../core/auth.service';
import { BaseService } from '../shared/base.service';
import { ClinicsService } from '../clinics/clinics.service';
import { AppService } from '../app.service';
import { DialogComponent } from '../dialog/dialog.component';
import { PasswordService } from '../auth/forgot-password/password.service';
import * as _ from 'lodash';
import { VouchersModel } from './vouchers.model';
import { B2CAdminComponent } from '../home/b2c-admin/b2c-admin.component';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../users/users.service';
import { HomeService } from '../home/home.service';
import { MaintenanceService } from '../maintenance/maintenance.service';
import { SecureApi } from '../core/secure.api';
import { MaintenanceComponent } from '../maintenance/maintenance.component';
import * as moment from 'moment';
import {CoreService} from "../core/core.service";
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'vouchers-component',
    templateUrl: './vouchers.component.html',
    styleUrls: ['./vouchers.component.scss'],
    providers: [VouchersService, ClinicsService, PasswordService ,BaseService]
})

export class VouchersComponent extends B2CAdminComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild('dialogLogo', { static: false }) dialogLogo: DialogComponent;
    @ViewChild('modalHistory',  {static: false}) modalHistory: ModalDirective;
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    @Input() url = '/admin/vouchers';
    roles: Object[] = [];
    clinics: Object[] = [];
    userRoleId: number;
    historyData: Object[] = [];

    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['code', 'Code', 'col-xs-2'],
        ['clinic_id', 'Clinic Id', 'col-xs-2'],
        ['name', 'Clinic', 'col-xs-2'],
        ['expiration_date', 'Expiration Date', 'col-xs-2'],
        ['active', 'Active', 'col-xs-2'],
        ['usages', 'Usages', 'col-xs-2'],
    ];

    // define what table columns to display [column key, label, css class]
    readonly historyColumns = [
        ['patient_id', 'Patient Id', 'col-xs-2'],
        ['created_at', 'Create at', 'col-xs-5'],
    ];
    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public vouchersService: VouchersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                public route: ActivatedRoute) {
        super(authService, coreService, router, translate,fb,  baseService, appService, usersService, homeService, clinicService , maintenanceService, secureApi, maintenanceComponent );
    }

    ngOnInit() {
        super.ngOnInit();

        this.searchInfo = new VouchersModel();
        this.sortedColumn = 'code';
        this.url = 'b2c-patients/clinic-vouchers';
        this.token = this.authService.user['token'];

        // sort
        this.initSorting();

        this.coreService.className = 'fluid';
        if(!this.isHome){
            return this.getItems();
        }
    }

    ngAfterViewInit() {
        switch (this.params['action']) {
            case 'create': {
                this.openFormModal({action: 'create', title: 'Add Vouchers', url: this.url});
                break;
            }
            case 'update': {
                if (this.params['component'] !== 'clinics') {
                    this.openFormModal({action: 'update', id: this.params['id'], title: 'Edit User', url: this.url});
                }
                break;
            }
            case 'read': {
                this.openFormModal({
                    action: 'read',
                    id: this.params['id'],
                    activated: this.params['activated'],
                    title: 'Voucher Details',
                    content: this.params['content'],
                    description: this.params['description'],
                    url: this.url
                });
                break;
            }
            case 'activate':
            case 'delete': {
                this.params['url'] = this.url;
                this.openConfirmModal(this.params);
                break;
            }
            default: {
                break;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    clearSearch() {
        this.searchInfo.active = '';
    }

    /**
     * @param params
     */
    openFormModal(params: Object) {
        this.initForm(params);

        this.vouchersService.read(params['id']).subscribe(response => {
            let editingVoucher = response['data'];
            this.languages = JSON.parse(localStorage.getItem('languages'));
            let form = {};
            this.clinics = response['clinics'] || []
            let disabled = params['action'] === 'read' ? true : false;

            for (let column in editingVoucher) {
                if (editingVoucher.hasOwnProperty(column)) {
                    form[column] = {value: editingVoucher[column], disabled: disabled};
                }
            }
            if (this.form != null) {
                this.form.reset(form);
            } else {
                this.form = this.fb.group(form);
            }

            /**
             * 2. Bind validator
             */
            // Add new user
            if (params['action'] === 'create') {
                // Reset validator for mobile
                this.form.controls['code'].setValidators([<any>Validators.pattern('\\+{1}[0-9\\s]+')]);
                this.form.controls['clinic_id'].setValue(this.clinics[0]['id']);
            } else if (params['action'] === 'update') {
                if(editingVoucher.expiration_date){
                    const expirationDate = moment(editingVoucher.expiration_date, this.dateFormat);
                    this.form.patchValue({
                        expiration_date: {
                            date: {
                                day: +expirationDate.format('D'),
                                month: +expirationDate.format('M'),
                                year: +expirationDate.format('Y')
                            }
                        }
                    });
                }
            }

            this.showModal();
        });
    }

    /**
     * @param params
     */
    openHistoryModal(params: Object) {
        this.params = params;
        this.vouchersService.getHistory(params['id']).subscribe(response => {
            this.historyData = response['data'];
            // prevent users from clicking outside to close the modal since that does not set the url correctly
            this.modalHistory.config.backdrop = false;
            this.modalHistory.config.ignoreBackdropClick = true;
            this.modalHistory.config.keyboard = false;
            // this ensures the form is displayed only when the data is ready
            // hide the app loading icon
            this.isLoading = false;
            this.modalHistory.show();
        });
    }


    getItems() {
        this.initPageSize(this.isHome);
        this.vouchersService.getAll(this.filters)
            .subscribe(data => {
                this.setData(data);
            });
    }

    setData(data: any): void {
        this.items = data['items'] || [];
        if (data.filters != null) {
            this.filters = data.filters;
            this.asyncFilters = observableOf(data.filters);
        }
        this.clinics = data['clinics'] || [];
        // if vouchers are empty, hide the page numbers below the vouchers list to prevent page redirection
        this.paginationHidden = this.items.length === 0;
        this.isLoading = false;
    }

    navigateRoute() {
        this.router.navigate(['./'], {
            relativeTo: this.route
        });
    }

    initForm(params: Object): void {
        this.params = params;
        // store the current page to be used later since this.currentPage will be set to 1 when opening the modal
        this.page = this.currentPage;
        let queryParams = {};

        for (const param in this.params) {
            if (param !== 'url' && this.params.hasOwnProperty(param)) {
                queryParams[param] = this.params[param];
            }
        }

        // reset errors
        this.resetErrors();
        this.formSubmitted = false;

        if (this.formDirective) {
            this.formDirective.resetForm();
        }

        // Notice: For popup navigation from the search on StartPage
        // Avoid to check multiple api called
        // this.router.navigate(['./'], {queryParams: queryParams, relativeTo: this.route});

        // display app loading icon
        this.isLoading = true;
    }

    sortVouchers(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }
        if (column === 'expiration_date') {
            column = 'expiration_date_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }

    hideModal() {
        if (this.sub) {
            this.form.controls['code'].clearValidators();
            this.sub.unsubscribe();
        }
        this.modal.hide();
    }

    active(voucher){
        this.vouchersService.activate(voucher['id']).subscribe(response => {
            return response['items'][0];
        });
    }

    submit(value, valid, form) {
        if(this?.form?.controls['expiration_date']?.value){
            let expirationDate = this.form.controls['expiration_date'].value;
            let formattedExpirationDate = moment({
                day: expirationDate.date.day,
                year: expirationDate.date.year,
                month: expirationDate.date.month - 1, // http://momentjs.com/docs/#/get-set/month/
            });
            this.form.controls['expiration_date'].setValue(formattedExpirationDate.format(this.dateFormat));
        } else{
            this.form.controls['expiration_date'].setValue("");
        }
        return super.submit(this.form.value, this.form.valid);
    }

    copyCode(column, code){
        if(column !== 'code'){
            return false;
        }

    }
}
